<template>
  <div>
    <div v-if="showSlider" class="practice-game-progress-wrapper">
      <div v-if="!notPassed" class="practice-game-answered-all">
        <span></span>
        You've answered all the questions.
        <a href="javascript:void(0);" @click="onResetGame()">Try again.</a>
      </div>
      <ul>
        <li
          v-for="(dot, index) in dotArray"
          :key="index">
            <a href="javascript:void(0);"
            :data-index="index"
            class="dot"
            :class="selectCurrentDot(index, dot.state)"
            @click="onOpenSlide(index)"
            @keyup.enter="onOpenSlide(index)"></a>
        </li>
      </ul>
    </div>
    <div v-if="showSlider" :class="`slideshow${game.id}`">
      <div v-for="(card, index) in randomizeCards" :key="card.id" class="slideshow-card">
        <cards-list-item
          @answerState="showAnswerState"
          :cardIndex="index"
          :color="indexColor(index)"
          :sliderNavClick="sliderNavClick"
          :card="card"
          :reseted="isReseted"
          :gameId="game.id"
          :language="game.language"
          />
      </div>
    </div>
    <div :class="`slideshow-arrows-nav${game.id} slideshow-arrows-nav`"></div>
    <div class="game-card-reset-button">
      <a href="javascript:void(0);" class="f-button blue small" @click="onResetGame()">Reset</a>
    </div>

  </div>
</template>


<script>
import $ from 'jquery'
import 'slick-carousel'
import CardsListItem from './cards_list_item'
import { shuffle } from 'lodash'

export default {
  props: {
    game: {
      type: Object,
      required: true
    }
  },

  components: {
    CardsListItem
  },

  data() {
    return {
      slides: this.game.cards,
      cardIndex: 0,
      dotArray: [],
      sliderNavClick: false,
      randomizeCards: shuffle(this.game.cards),
      isReseted: 0,
      showSlider: true
    }
  },

  computed: {
    notPassed() {
      return this.dotArray.some(x => x.state == '')
    }
  },

  mounted() {
    this.slideshowInit()
    this.initDotArray()
  },

  methods: {
    initDotArray() {
      this.dotArray = this.slides.map(dot => ({ state: '' }))
    },

    indexColor(index) {
      return index % 5
    },

    selectCurrentDot(index, state) {
      let dotclass = ''
      if (this.cardIndex == index) {
        dotclass+=' current-dot '
      }
      dotclass+=state
      return dotclass
    },

    slideshowInit() {
      const $slideshow = $(".slideshow" + this.game.id)
      $slideshow.slick({
        draggable: false,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        appendArrows: $('.slideshow-arrows-nav' + this.game.id)
      })

      const that = this
      $slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        that.cardIndex = nextSlide
        that.sliderNavClick = true
      });
      $slideshow.on('afterChange', function(event, slick, currentSlide, nextSlide){
        that.sliderNavClick = false
      });
    },

    showAnswerState(options) {
      this.dotArray.forEach((slide, index) => {
        if (index == options.index) {
          slide.state = options.state
        }
      })
    },

    onOpenSlide(index) {
      $(".slideshow" + this.game.id).slick('slickGoTo', index, false)
    },

    onResetGame() {
      this.isReseted += 1

      const $slideshow = $('.slideshow' + this.game.id)
      $slideshow.slick('unslick') // destroy slick slider
      this.showSlider = false   // hide slider to update DOM
      this.randomizeCards = shuffle(this.randomizeCards)

      this.initDotArray()  // reinit dots state after reset

      setTimeout(() => {
        this.showSlider = true;
        this.$nextTick(() => { // waiting for the next DOM update flush
          this.slideshowInit()
          this.cardIndex = 0
        });
      }, 10);
    }
  }
}
</script>
